import type { GridColDef } from '@mui/x-data-grid';
import type { CampaignListEntry } from '@features/campaign-list';
import { formatters } from '@utils/formattersV2';
import { parseReportDateToLocaleFormat } from '@utils/dates';

export type ExportCampaignRow = Pick<
  CampaignListEntry,
  | 'campaignId'
  | 'campaignName'
  | 'advertiserTeamName'
  | 'campaignStartDate'
  | 'campaignEndDate'
  | 'impressions'
  | 'salesLift'
  | 'visitLift'
>;

export const exportColumns: GridColDef<ExportCampaignRow>[] = [
  { field: 'campaignId', headerName: 'ID', flex: 0.5, minWidth: 70 },
  {
    field: 'campaignName',
    headerName: 'Campaign Name',
    flex: 1.5,
    minWidth: 150,
  },
  { field: 'advertiserTeamName', headerName: 'Advertiser', flex: 1 },
  {
    field: 'campaignStartDate',
    headerName: 'Start Date',
    flex: 1,
    valueFormatter: (value: ExportCampaignRow['campaignStartDate']) =>
      parseReportDateToLocaleFormat(value),
  },
  {
    field: 'campaignEndDate',
    headerName: 'End Date',
    flex: 1,
    valueFormatter: (value: ExportCampaignRow['campaignEndDate']) =>
      parseReportDateToLocaleFormat(value),
  },
  {
    field: 'impressions',
    headerName: 'Impressions',
    flex: 1,
    valueFormatter: (value: ExportCampaignRow['impressions']) =>
      formatters.impressions(value),
  },
  {
    field: 'salesLift',
    headerName: 'Incr. Sales Lift',
    flex: 1,
    valueFormatter: (value: ExportCampaignRow['salesLift']) =>
      formatters.lift(value),
  },
  {
    field: 'visitLift',
    headerName: 'Incr. Visit Lift',
    flex: 1,
    valueFormatter: (value: ExportCampaignRow['visitLift']) =>
      formatters.lift(value),
  },
];
